module.exports = __webpack_public_path__ + "static/iphone-bottom-2d963d5cd8d28cbbd33a3165b96a5d92.jpg";